export default "__VITE_ASSET__D2TB$O4B__"